export enum CommunicationsType {
    Phone = 1,
    Email,
    Message,
    Meeting,
    Conversation,
    Letter,
    Other
}

export enum CommunicationOutcomes {
    SpokeToContactSuccess = 'Spoke to Contact - Successful call',
    EngagedButWrongContact = 'Engaged conversation but not the right contact',
    NoResponse = 'Called but no response',
    WrongContactDetails = 'Wrong contact details',
}


// these action numbers correspond to the 4 outcomes above
export enum CommunicationActions {
    SendNDA = 0, // = '0',
    FurtherCallBooked, // = '0',
    EmailToBeResent, // = '0',
    FindRightContact, // = '1,2,3',
    TryToCallAgain, // = '2',
}

// 1. Spoke a contact – successful call
// (which would then pop up to any action / trigger from the call which could be Send NDA, Further Call Booked, Email to be re - sent).
// 2. Engaged conversation but not the right contact(so this would trigger an action for us to find right contact)
// 3.Called but didn’t get through(trigger to try again)
// 4.Wrong contact details(again a trigger).

// Not sure if we could also have some kind of traffic light system going on here to make things clearer. 



// WEBPACK FOOTER //
// ./client/app/shared/communications/communication-types.enum.ts